import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AuthState } from './auth.entity';
import { selectAll } from './auth.reducers';
import { AppState } from './../../store/reducers/index';

export const authFeatureSelector = createFeatureSelector<AuthState>('authState');

// export const userLogin = createSelector(
//     authFeatureSelector,
//     selectAll
// );

export const loggedInUser = createSelector(
    authFeatureSelector,
    state => state?state.user: null
);

export const userLoginFailure = createSelector(
    authFeatureSelector,
    state => state.error
);



